import './App.css';
import React from "react";
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import Authentication from './Pages/Authentication/Authentication';
import Logout from './Pages/Logout/Logout';
import UserLinks from './Pages/UserLinks/UserLinks';
import NotFound from './Pages/NotFound/NotFound';
import Home from './Pages/Home/Home';
import Profile from './Pages/Profile/Profile';
import SendPasswordReset from './Pages/SendPasswordReset/SendPasswordReset';
import PasswordReset from './Pages/PasswordReset/PasswordReset';
import TermsAndConditions from './Pages/TermsAndConditions/TermsAndConditions';
import PrivacyPolicy from './Pages/PrivacyPolicy/PrivacyPolicy';
import DefaultLayout from './Components/DefaultLayout/DefaultLayout';
import UserLinksLayout from './Components/UserLinksLayout/UserLinksLayout';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './Components/ProtectedRoute/PrivateRoute';

function App() {
  const darkTheme = createTheme({
    palette: {
      mode: 'dark',
      type: 'dark',
      primary: {
        main: '#e8e7e7',
        contrastText: '#0f1c29',
        dark: '#fff',
      },
      secondary: {
        main: '#89253e',
        contrastText: '#fff'
      },
      background: {
        default: '#0f1c29',
        paper: '#122435',
      },
      text: {
        primary: '#fff',
        secondary: 'rgba(255,255,255,0.7)',
        disabled: 'rgba(255,255,255,0.5)',
      },
    },
    typography: {
      fontFamily: 'Poppins, sans-serif',
    },
  });

  return (
    <ThemeProvider theme={darkTheme}>
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route element={<DefaultLayout />}>
              <Route path="/" Component={Home} />
              <Route path="/signup" element={<Authentication type="create" />} />
              <Route path="/login" element={<Authentication type="login" />} />
              <Route path="/sendPasswordReset" Component={SendPasswordReset} />
              <Route path="/passwordReset" Component={PasswordReset} />
              <Route path="/termsAndConditions" Component={TermsAndConditions} />
              <Route path="/privacyPolicy" Component={PrivacyPolicy} />
              <Route path="/404" Component={NotFound} />
              <Route path="*" element={<Navigate to="/404" />} />
            </Route>
            <Route element={<ProtectedRoute />}>
              <Route path="/logout" Component={Logout} />
              <Route path="/profile" Component={Profile} />
            </Route>
            <Route element={<UserLinksLayout />}>
              <Route path="/:user" Component={UserLinks} />
            </Route>
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
